import { __rest } from 'tslib';
import React__default, { useEffect } from 'react';
import { CORE_SIZE } from './constants.es.js';
import { MinusOutlined, AddOutlined } from '@teko/ds-icon';
import { CommonStyles } from './components/BaseProps.es.js';
import { I as InputNumber } from './InputNumber-2574c4cd.js';
import { styled } from '@teko/styled';

const QuantitySize = {
    s: {
        height: CORE_SIZE.s32,
        width: '6.375rem',
    },
    m: {
        height: CORE_SIZE.s40,
        width: '6.375rem',
    },
};
const QuantityWrapper = styled.div((props) => [
    CommonStyles,
    `
  height: ${QuantitySize[props.size].height};
  width: ${props.block ? '100%' : QuantitySize[props.size].width};
  border-radius: ${props.theme.borderRadius.s};
  background: ${props.disabled
        ? props.theme.colors.background
        : props.theme.colors.tableHeader};
  ${!props.disabled
        ? `border: ${props.theme.borderWeight.m} solid ${props.theme.colors[props.color] || props.theme.colors.divider};`
        : ''}
  display: flex;
  align-items: center;
  overflow: hidden;
`,
]);
const Plus = styled.button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? 'cursor: not-allowed;' : ''}
`);
const Minus = styled.button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? 'cursor: not-allowed;' : ''}
`);
const InputWrapper = styled.div(({ color, theme }) => {
    var _a;
    return `
  flex: 1;
  .wrap-input-number {
    padding: 0;
    border: none;
    background-color: transparent;
  }
  .wrap-input-number input {
    text-align: center;
    background-color: transparent;
    font-size: 0.8125rem;
    font-weight: 500;
    color: ${color ? ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a[color]) || color : 'rgb(67, 70, 87)'};
  }
`;
});
const Quantity = (_a) => {
    var { min = 1, max = 999, quantity = 1, precision, decimalSeparator = ',', step = 1, size = 's', disabled, disableInput, disableMinus, disablePlus, className, onMinus, onPlus, setQuantity, color, block } = _a, rest = __rest(_a, ["min", "max", "quantity", "precision", "decimalSeparator", "step", "size", "disabled", "disableInput", "disableMinus", "disablePlus", "className", "onMinus", "onPlus", "setQuantity", "color", "block"]);
    const isOverMax = (value) => {
        if (max && value > max)
            return true;
        return false;
    };
    const isUnderMin = (value) => {
        if (min && value < min)
            return true;
        return false;
    };
    const onChange = (value) => {
        var _a, _b;
        const splitValue = (_a = value === null || value === void 0 ? void 0 : value.toString()) === null || _a === void 0 ? void 0 : _a.split('.');
        let newQuantity = !(splitValue === null || splitValue === void 0 ? void 0 : splitValue[1]) || ((_b = splitValue === null || splitValue === void 0 ? void 0 : splitValue[1]) === null || _b === void 0 ? void 0 : _b.length) <= 2 ? value : quantity;
        if (isOverMax(value))
            newQuantity = max;
        if (isUnderMin(value))
            newQuantity = min;
        setQuantity(newQuantity);
    };
    const onDecrease = () => {
        if (onMinus)
            onMinus();
        onChange(quantity - step);
    };
    const onIncrease = () => {
        if (onPlus)
            onPlus();
        setQuantity(quantity + step);
    };
    const disableMinusButton = disabled || disableMinus || quantity === min;
    const disablePlusButton = disabled || disablePlus || quantity === max;
    const disableInputField = disabled || disableInput;
    useEffect(() => {
        if (isOverMax(quantity))
            setQuantity(max);
        if (isUnderMin(quantity))
            setQuantity(min);
    }, [min, max]);
    return (React__default.createElement(QuantityWrapper, Object.assign({ className: className, size: size, block: block, disabled: disabled, color: color, onClick: (e) => e.preventDefault() }, rest),
        React__default.createElement(Minus, { disabled: disableMinusButton, onClick: onDecrease, color: color },
            React__default.createElement(MinusOutlined, { color: disableMinusButton ? 'disable' : color || 'textPrimary', size: 16 })),
        React__default.createElement(InputWrapper, { color: color },
            React__default.createElement(InputNumber, { value: quantity, onFocus: (event) => event.target.select(), onChange: onChange, disabled: disableInputField, controls: false, min: min, max: max, step: step, precision: precision, decimalSeparator: decimalSeparator })),
        React__default.createElement(Plus, { disabled: disablePlusButton, onClick: onIncrease, color: color },
            React__default.createElement(AddOutlined, { color: disablePlusButton ? 'disable' : color || 'textPrimary', size: 16 }))));
};

export { Quantity as Q };
